<template>
  <div class="footer">
    <div class="footerNav">
      <!-- <div
        class="btn"
        :class="activeId === index ? 'btn1' : ''"
        v-for="(item, index) in btnList"
        :key="index"
        @click="handleChangeTab(index, item.url)"
      >{{item.name}}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  // props: {
  //   btnList: {
  //     type: Array,
  //     default: []
  //   }
  // },
  data () {
    return {
      activeId: null,
    }
  },
  // watch: {
  //   '$route': {
  //     handler () {
  //       this.getRouter()
  //       this.init()
  //     }
  //   }
  // },
  mounted () {
    // this.getRouter()
    // this.init()
    // this.$router.push("runOpen")
  },
  methods: {
    // init () {
    //   this.btnList.map((item, index) => {
    //     if (item.url === this.$route.name) {
    //       this.activeId = index
    //     }
    //   })
    // },
    // getRouter () {
    //   let str = this.$route.path.split('/')[1].split('_')[1]
    //   this.routerBack = this.$route.path.split('/')[2]
    //   this.$store.commit('set_routerSelect', str)

    // },
    // handleChangeTab (index, url) {
    //   if (url === '') return
    //   this.$router.push(url)
    //   // this.$emit("FooterClick", url)
    // }
  }
}
</script>

<style lang="stylus" scoped>
.footer
  position absolute
  pointer-events none
  // z-index 9999999
  bottom 0
  // height 100%
  width 100%
  height 61px
  background url('../../assets/images/footerBg.png') no-repeat bottom center / 100% auto
  // z-index -9
.footerNav
  display flex
  justify-content space-between
  position absolute
  bottom 80px
  left 50%
  transform translateX(-50%)
  width 880px
  height 42px
  .btn
    pointer-events auto
    display flex
    justify-content center
    align-items center
    width 157px
    height 100%
    font-size 18px
    color #ABC2DE
    letter-spacing 0.5px
    cursor pointer
    background url('../../assets/images/btnBg.png') no-repeat center / 100% 100%
    // &:hover
    //   font-size 20px
    //   font-weight 600
    //   color #FFFFFF
    //   text-shadow 0px 0px 6px #00FFE5
    //   background url('../../assets/images/btnBg1.png') no-repeat center / 100% 100%
  .btn1
    font-size 20px
    font-weight 600
    color #FFFFFF
    text-shadow 0px 0px 6px #00FFE5
    pointer-events auto
    background url('../../assets/images/btnBg1.png') no-repeat center / 100% 100%
</style>